import React from "react";
import { Button } from "@vitalsource/vstui";
import {
  actions as routerActions,
  selectors as routerSelectors
} from "../../../redux/router";
import { connect } from "react-redux";

class Link extends React.Component {
  handleClick = e => {
    const { onClick, go, href } = this.props;
    let destination = href;
    if (destination.indexOf("/") === 0) {
      destination = destination.slice(1);
    }
    if (onClick) {
      onClick(e);
    }

    if (!e.defaultPrevented) {
      go(destination);
    }

    e.preventDefault();
  };

  render() {
    return <Button {...this.props} onClick={this.handleClick} />;
  }
}

const mapStateToProps = state => ({
  route: routerSelectors.getCurrentRoute(state)
});

const mapDispatchToProps = dispatch => ({
  go: destination => dispatch(routerActions.go(destination))
});

export default connect(mapStateToProps, mapDispatchToProps)(Link);
